import React from "react";

const Instructions = () => {
  return (
    <div>
      <p>If the prompt still doesn&apos;t appear:</p>
      <ul>
        <li>
          Go to{" "}
          <strong>
            Settings {">"} Privacy & Security {">"} Camera
          </strong>
        </li>
        <li>Enable camera access</li>
        <li>Reload the page</li>
      </ul>
    </div>
  );
};

export default Instructions;
